// ignore-string-externalization

export class ResponseError extends Error {
  constructor(response: $TSFixMe) {
    super(`${response.status}: ${response.url}`);
    this.name = 'ResponseError';
  }
}
